import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CodeToggle,
  headingsPlugin,
  listsPlugin,
  ListsToggle,
  MDXEditor,
  quotePlugin,
  Separator,
  StrikeThroughSupSubToggles,
  toolbarPlugin,
  UndoRedo
} from '@mdxeditor/editor';
import { styled } from "@mui/material/styles";

import '@mdxeditor/editor/style.css';

import { InputLabel } from '@mui/material';
import MDBox from 'components/MDBox';
import { forwardRef, useState } from 'react';
import './styles.css';
const Editor = styled(MDXEditor)(({ theme }) => ({
  zIndex: 1100,
}));


const MDXEditorComponent = forwardRef(({
  label,
  value = '',
  onChange,
  height = '600px',
  placeholder = 'Type your MDX here...',
  ...rest
}, ref) => {
  const [editorValue, setEditorValue] = useState(value||"");

  const handleChange = (newValue) => {
    setEditorValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };
  
  return (
    <MDBox sx={{ width: '100%', height: {
      xs: '700px',  // phones
      sm: '650px',  // tablets
      md: '600px',  // desktops
    } }}>
      <InputLabel sx={{ marginBottom: 1 }} htmlFor={label}>
        {label}
      </InputLabel>
      <Editor
        {...rest}
        ref={ref}
        onChange={handleChange}
        markdown={editorValue}
        plugins={[
          headingsPlugin(),
          listsPlugin(),
          quotePlugin(),
          toolbarPlugin({
            toolbarContents: () => (
              <>
                <UndoRedo/>
                <Separator/>

                <BoldItalicUnderlineToggles/>
                <CodeToggle/>
                <Separator/>

                <StrikeThroughSupSubToggles/>
                <Separator/>

                <ListsToggle/>
                <Separator/>

                <BlockTypeSelect />
              </>
            ),
          }),
        ]}
      />
    </MDBox>
  );
});

export default MDXEditorComponent;
